import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PipManager from '../../utils/pipManager/PipManager';
import Device from "../../devices/device";

import './styles/ModalErrorGeneric.css';
import './styles/ModalActualizationEPGVersion.css';


const ModalGeneric = (props) => {
  const asset = props.asset || false;
  const title = props.title || false;
  const content = props.content || false;
  const children = props.children || false;
  let buttons = [];
  const callback = props.callback || false;
  const buttonsAlign = props.buttonsAlign || 'vertical';
  const withCancel = props.withCancel || false;
  const sizeLogo = { width: "95.18", height: "24.21"}
  const imgLogo = "soa_apa_claroVideo_logo"

  //Se migró esta funcion al ModalWrapper
  //PipManager.closePIP(Device,false);


  if (withCancel) {
    const buttonCancel = Translator.get('modal_default_cancel', 'Cancelar');
    buttons.push({
      content: buttonCancel,
      props: {
        onClick: (e) => {props.handleClose(e, callback)},
      }
    });
  }

  if (props.buttons) {
    const tmp = props.buttons.map(button => {
      const newButton = Object.assign({}, button);
      const cb = newButton.props.onClick;
      newButton.props.onClick = (e) => {
        props.handleClose(e, cb);
        PipManager.resizePIP();
      };
      return newButton;
    });
    buttons = [...buttons, ...tmp];
  }

  const p = {
    buttonsAlign,
    buttons,
    onOpen: props.onOpen,
    className: props.className,
    callbackWhenBack: props.callbackWhenBack,
    aafNewStyle: props.aafNewStyle,
    extraClass: '',
    sizeLogo,
    imgLogo,
  };

  if (asset) p['asset'] = asset;
  if (title) p['title'] = title;
  if (content) p['content'] = content;
  if (children) p['children'] = children;


  return <ModalWrapper {...p} />;
}

export default withOnClose(ModalGeneric);



// WEBPACK FOOTER //
// ./src/components/Modal/ModalEpgVersion.jsx